module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter",
    attrs: {
      "id": "c16"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }), _vm._v("Once, Twice, Three Time a Lady")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("A twenty-four-year-old woman in Beloit, Wisconsin, was charged with battery for allegedly hitting her husband with a plant stand, sending him to the hospital for six stitches. According to the police statement, the newlyweds frequently fought about sex. The night of the attack the woman became enraged because her husband decided to call it quits after only four sexual encounters with her that day."), _c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/Greg_9780740792069_epub_L04_r1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "textbox"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/Greg_9780740792069_epub_L07_r1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center02"
  }, [_vm._v("“[The victim] also has difficulty sleeping, driving his manual car and has lost his "), _c('span', {
    staticClass: "big1"
  }, [_vm._v("libido")]), _vm._v(",” ruled an Australian judge, who also awarded "), _c('span', {
    staticClass: "big1"
  }, [_vm._v("$432,000")]), _vm._v(" to a fifty-four-year-old man who lost his sex drive after being attacked by a "), _c('span', {
    staticClass: "big1"
  }, [_vm._v("pig.")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/Greg_9780740792069_epub_L07_r1.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa9373c8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780740792069_epub_c16_r1.vue
// module id = 120
// module chunks = 0